import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { CrudEntityType, CrudPermissions } from './groups/group-names/acm-permissions';
import { UserGroupsService } from './groups/user-groups.service';
import { PermissionsService } from './permissions.service';

export const hasPermission = (entity: CrudEntityType, crudOp: keyof CrudPermissions) => {
    const permissionsService = inject(PermissionsService);
    const groupsService = inject(UserGroupsService);
    return permissionsService.permissions$.pipe(
        switchMap((permissions) => groupsService.hasAnyGroup(permissions[entity][crudOp]))
    );
};
